import axios from 'axios';
import rebrand from '../../config/rebrand';

export default class Theme {
  get(slug) {
    let path = '/themes/list.json';

    if (slug) {
      path = `/themes/${slug}/presets.json`;
    }
    return axios.get(`${rebrand.urls.THEME_CDN_URI}${path}`);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/theme.js
 **/